@for (anleitung of anleitungen$ | async; track anleitung; let i = $index) {
  <div class="anleitungen">
    <ufla-anleitungen-upload (fileChange)="uploadAnleitung($event)"
      (deleteFileTrigger)="deleteAnleitungByRole($event)"
      (downloadTrigger)="this.anleitungService.downloadFile($event)"
    [anleitungsdokument]="anleitung">
    </ufla-anleitungen-upload>
    <!-- display upload progress -->
    @if (uploading && lastUploadedNeueAnleitung.organisationsTyp === anleitung.organisationsTyp) {
      <div class="upload-progress">
        <mat-label class="padding-left">Lade hoch...</mat-label>
        <mat-progress-bar [value]="uploadProgress" mode="determinate"></mat-progress-bar>
      </div>
    }
  </div>
}




